<template>
  <article
    class="
      shadow-md
      mx-auto
      transform
      duration-300
      hover:shadow-2xl
      dark
      w-96
      bg-gradient-radial
      to-indigo-300/70
      from-cyan-300/50
      rounded-lg
      flex-none
    "
  >
    <div class="px-7 pt-7 my-auto pb-8">
      <div @click="changeAnonymous()" class="cursor-pointer">
        <h1
          class="text-2xl font-extrabold text-white break-all"
          v-if="!anonymous"
        >
          {{ username }}
        </h1>
        <h1 class="text-2xl font-extrabold text-white break-all" v-else>
          Anonymous
        </h1>
      </div>
      <h3 class="text-xl font-semibold text-white mt-2">
        At the age of {{ age }}
      </h3>
      <p
        class="
          text-xl
          leading-relaxed
          text-white
          mt-5
          overflow-y-scroll
          max-h-96
          duration-300
          whitespace-pre-line
          font-bold font-sans
        "
        :contenteditable="atCreationPage"
        @focus="focusOnEdit()"
        @blur="updateText($event)"
        @mouseover="hoverOver = true"
        @mouseleave="hoverOver = false"
        :class="blurPost && !hoverOver ? 'blur' : ''"
      >
        {{ postText }}
      </p>
    </div>
    <h5 class="pb-3 text-white">
      Posted on
      <span
        @click="changeBlurPost()"
        :class="atCreationPage ? 'cursor-pointer' : ''"
        >{{ postDate }}
      </span>
    </h5>
    <div class="flex flex-row justify-between blue my-3">
      <div class="mx-4 flex">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="
            h-9
            w-9
            duration-300
            hover:fill-blue-500 hover:stroke-lime-100 hover:scale-110
          "
          viewBox="0 0 24 24"
          @click="sendLikePost()"
          :class="
            (atCreationPage ? likePost : userLikePost)
              ? 'fill-blue-600 stroke-lime-200'
              : 'fill-transparent stroke-current'
          "
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
          />
        </svg>
        <h1
          class="
            align-middle
            my-auto
            text-2xl
            font-bold
            text-left
            pl-2
            text-white
          "
          v-if="likeCount != 0"
        >
          {{ likeCount }}
        </h1>
      </div>
      <div class="mx-4 flex">
        <h1
          class="
            align-middle
            my-auto
            text-2xl
            font-bold
            text-right
            pr-2
            text-white
          "
          v-if="dislikeCount != 0"
        >
          {{ dislikeCount }}
        </h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="
            h-9
            w-9
            duration-300
            hover:fill-red-500 hover:stroke-pink-100 hover:scale-110
          "
          viewBox="0 0 24 24"
          @click="sendDislikePost()"
          :class="
            (atCreationPage ? dislikePost : userDislikePost)
              ? 'fill-red-600 stroke-pink-200'
              : 'fill-transparent stroke-current'
          "
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
          />
        </svg>
      </div>
    </div>
  </article>
</template>

<script>
import { cardStyleMixin } from "../mixins/CardStyleMixin.js";
export default {
  name: "CardStyle0",
  mixins: [cardStyleMixin],
  props: {
    postText: String, // the post text
    anonymous: Boolean, // wheather this post is anonymous or not
    age: Number, // the age at which this is made
    atCreationPage: Boolean,
    username: String, // the user name
    likeCount: Number, // the number of likes on this
    dislikeCount: Number, // the number of dislikes on this
    postDate: String, // the date when it was posted
    blurPost: Boolean, // wheather to blur the post or not
    likePost: Boolean, // is this post liked by user
    dislikePost: Boolean, // is this post disliked by user
    postID: Number,
  },
};
</script>
<style scoped>
::-webkit-scrollbar {
  width: 0; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
</style>